<template>
    <div class="container" style="width: 60%">
        <div class="red pb20" v-if="audit_status == 2">
            <p>审核失败，原因如下：</p>
            <p>{{audit_tips}}</p>
        </div>
        <el-form :model="form" size="mini" label-width="170px" ref="form" :rules="rules" :disabled="audit_status == '0' || audit_status == 1 || audit_status == 3 || audit_status == 4 || audit_status == 5">
            <div class="f16 bold pb20">1、商家账户信息</div>
            <el-form-item label="商户邮箱" prop="email">
                <span slot="label">
                    商户邮箱
                    <el-tooltip placement="right">
                        <div slot="content">
                            邮箱是商户的快钱账号，后续会接收来自快钱的激活邮件，每个商户邮箱都是唯一不可重复的
                        </div>
                        <i class="el-icon-question primary"></i>
                    </el-tooltip>
                </span>
                <el-input v-model="form.email" placeholder="请输入" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="结算账号类型" prop="settleAccType">
                <span slot="label">
                    结算账号类型
                    <el-tooltip placement="right">
                        <div slot="content">
                            若银行账号为商户本人账号，则选择法人即可（多数情况）；<br>
                            若后面银行账号为对公账号，则选择企业；<br>
                            若打款账号非商户自己账号而是授权给别人或公司，则选择授权人或对公授权人；
                        </div>
                        <i class="el-icon-question primary"></i>
                    </el-tooltip>
                </span>
                <el-select v-model="form.settleAccType" placeholder="请选择">
                    <el-option label="企业" :value="0"></el-option>
                    <el-option label="法人" :value="1"></el-option>
                    <el-option label="授权人" :value="2"></el-option>
                    <el-option label="对公授权人" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <div v-if="form.settleAccType == 1">
                <el-form-item label="" prop="">
                    <div class="red f12" style="line-height: 20px">
                      法人结算类型下需要单独告知快钱进件人员，请务必在完成系统进件信息提交后，将商户账号（邮箱账号）告知对接的快钱进件人员
                    </div>
                </el-form-item>
            </div>
            <!--结算账号类型 授权人-->
            <div v-if="form.settleAccType == 2">
                <el-form-item label="" prop="">
                  <div class="red f12" style="line-height: 20px">
                    <p>授权人结算类型下需要额外提供两份材料，请在完成系统进件信息提交后，将商户账号（邮箱账号）+两份材料发给对接的快钱进件人员：</p>
                    <p>1、商户提供结算意愿确认函 ，需盖章；<a class="cursor primary" href="http://qnvideo.anlaiye.com.cn/853d484af8d44c8a8da987025779ed3a.doc">点击下载模板</a></p>
                    <p>2、商户和授权人出具的关系说明（商户自拟），两个主体都要在上面盖章；</p>
                  </div>
                </el-form-item>
                <el-form-item label="身份证人像面照片" prop="authIdCardPersonFssId">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'authIdCardPerson')}">
                        <div class="icons" v-if="form.authIdCardPerson">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.authIdCardPerson)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
                        <img v-if="form.authIdCardPerson" :src="form.authIdCardPerson" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="身份证国徽面照片" prop="authIdCardNationalFssId">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'authIdCardNational')}">
                        <div class="icons" v-if="form.authIdCardNational">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.authIdCardNational)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
<!--                        <i v-if="form.authIdCardNational" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.authIdCardNational)"></i>-->
                        <img v-if="form.authIdCardNational" :src="form.authIdCardNational" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="授权人姓名" prop="authIdCardName">
                    <el-input v-model="form.authIdCardName" placeholder="请输入" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="授权人身份证号" prop="authIdCardNumber">
                    <el-input v-model="form.authIdCardNumber" maxlength="18" placeholder="请输入请输入15位或者18位身份证号" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="有效期开始时间" prop="authIdCardBeginDate">
                    <el-date-picker
                        v-model="form.authIdCardBeginDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="有效期结束时间" prop="authIdCardExpireDate">
                    <el-date-picker
                        v-model="form.authIdCardExpireDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="授权人手机号" prop="authTel">
                    <el-input maxlength="11" v-model="form.authTel" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <el-form-item label="银行账号" prop="pay_account">
                <el-input v-model="form.pay_account" placeholder="请输入" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="账户名称" prop="pay_name">
                <el-input v-model="form.pay_name" placeholder="请输入" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="银行名称" prop="bank_id">
                <el-select
                    v-model="form.bank_id"
                    filterable
                    clearable
                    placeholder="请输入银行"
                    @change="getBankBranch()">
                    <el-option v-for="p in banks" :label="p.n" :value="p.k" :key="p.k"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支行全称" prop="bank_branch_id">
                <el-select
                    v-model="form.bank_branch_id"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="请输入支行"
                    :loading="loading"
                    @change="getBranchName()"
                    :remote-method="bankRemoteMethod">
                    <el-option
                        v-for="item in bankBranchs"
                        :key="item.k"
                        :label="item.n"
                        :value="item.k">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开户行区域" prop="bank_area">
                <el-cascader
                    v-model="form.bank_area"
                    :options="distinctData"
                    :props="{ value: 'id' }"
                    style="width: 100%"
                ></el-cascader>
            </el-form-item>
            <el-form-item label="开户行手机号" prop="pay_mp"
                          v-if="form.settleAccType == 1 || form.settleAccType == 2">
                <el-input maxlength="11" v-model="form.pay_mp" placeholder="请输入" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="银行卡照片" prop="bankCardFssId" :rules="[{ required: true, message: '请上传银行卡照片'}]" v-if="form.settleAccType == 2 || form.settleAccType == 3">
                <el-upload
                    class="avatar-uploader"
                    :action="$apiUrl.imgUpload"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :on-success="(res,file) => {return handleAvatarSuccess(res,file,'bankCard')}">
<!--                    <i v-if="form.bankCard" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.bankCard)"></i>-->
                    <div class="icons" v-if="form.bankCard">
                        <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.bankCard)"></i>
                        <i class="el-icon-upload2"></i>
                    </div>
                    <img v-if="form.bankCard" :src="form.bankCard" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <div class="f16 bold pb20">2、商户主体资料</div>
            <el-form-item label="主体类型" prop="subjectType">
                <span slot="label">
                    主体类型
                    <el-tooltip placement="right">
                        <div slot="content">
                            非公司企业商户直接选择个体工商户即可（多数情况）;<br>
                            若为公司企业则根据公司企业性质选择对应主体类型
                        </div>
                        <i class="el-icon-question primary"></i>
                    </el-tooltip>
                </span>
                <el-select v-model="form.subjectType" placeholder="请选择" @change="changeSubjectType()">
                    <el-option label="小微/小个体" :value="0"></el-option>
                    <el-option label="有限责任公司" :value="1"></el-option>
                    <el-option label="股份有限责任公司" :value="2"></el-option>
                    <el-option label="私营合伙企业" :value="3"></el-option>
                    <el-option label="私营独资企业" :value="4"></el-option>
                    <el-option label="个体工商户" :value="5"></el-option>
                    <el-option label="非公司企业法人" :value="6"></el-option>
                </el-select>
            </el-form-item>
            <!--有限责任公司、股份有限责任公司、私营合伙企业、私营独资企业、个体工商户 自动带出营业执照相关信息-->
            <div
                v-if="form.subjectType == 1 || form.subjectType == 2 || form.subjectType == 3 || form.subjectType == 4 || form.subjectType == 5">
                <el-form-item label="营业执照照片" prop="licensePicFssId"
                              :rules="[{ required: true, message: '请选择营业执照照片'}]">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'licensePic')}">
<!--                        <i v-if="form.licensePic" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.licensePic)"></i>-->
                        <div class="icons" v-if="form.licensePic">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.licensePic)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
                        <img v-if="form.licensePic" :src="form.licensePic" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="注册号/统一社会信用代码" prop="businessRegno"
                              :rules="[{ required: true, message: '请输入注册号/统一社会信用代码'}]">
                    <el-input maxlength="18" v-model="form.businessRegno" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="商户名称" prop="merchantName" :rules="[{ required: true, message: '请输入商户名称'}]">
                    <el-input v-model="form.merchantName" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="法人姓名/个体户经营者" prop="legalName"
                              :rules="[{ required: true, message: '请输入法人姓名/个体户经营者'}]">
                    <el-input v-model="form.legalName" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经营范围" prop="merchantConstraintBusiness"
                              :rules="[{ required: true, message: '请输入经营范围'}]">
                    <el-input v-model="form.merchantConstraintBusiness" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经营场所地区编码" prop="merchantArea"
                              :rules="[{ required: true, message: '请选择经营场所地区'}]">
                    <!--                    <el-input v-model="form.merchantAreaCode" placeholder="请输入"-->
                    <!--                              auto-complete="off"></el-input>-->
                    <el-cascader
                        v-model="form.merchantArea"
                        :options="distinctData"
                        :props="{ value: 'id' }"
                        style="width: 100%"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="经营地址" prop="merchantAddress"
                              :rules="[{ required: true, message: '请输入经营地址'}]">
                    <el-input v-model="form.merchantAddress" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="营业证起始时间" prop="licenseHandleDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.licenseHandleDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="营业证结束时间" prop="licenseCancelDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.licenseCancelDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <div v-if="form.businessRegno.length == 15">
                    <el-form-item label="组织机构代码证照片" prop="orgFssId"
                                  :rules="[{ required: true, message: '请选择组织机构代码证照片'}]">
                        <el-upload
                            class="avatar-uploader"
                            :action="$apiUrl.imgUpload"
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                            :on-success="(res,file) => {return handleAvatarSuccess(res,file,'org')}">
<!--                            <i v-if="form.org" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.org)"></i>-->
                            <div class="icons" v-if="form.org">
                                <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.org)"></i>
                                <i class="el-icon-upload2"></i>
                            </div>
                            <img v-if="form.org" :src="form.org" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="组织机构代码" prop="orgCode"
                                  :rules="[{ required: true, message: '请输入组织机构代码'}]">
                        <el-input v-model="form.orgCode" placeholder="请输入"
                                  auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记证照片" prop="taxFssId"
                                  :rules="[{ required: true, message: '请选择税务登记证照片'}]">
                        <el-upload
                            class="avatar-uploader"
                            :action="$apiUrl.imgUpload"
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                            :on-success="(res,file) => {return handleAvatarSuccess(res,file,'tax')}">
<!--                            <i v-if="form.tax" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.tax)"></i>-->
                            <div class="icons" v-if="form.tax">
                                <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.tax)"></i>
                                <i class="el-icon-upload2"></i>
                            </div>
                            <img v-if="form.tax" :src="form.tax" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="税务登记证代码" prop="taxCode"
                                  :rules="[{ required: true, message: '请输入税务登记证代码'}]">
                        <el-input v-model="form.taxCode" placeholder="请输入"
                                  auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <!-- 非公司企业法人-->
            <div v-if="form.subjectType == 6">
                <el-form-item label="证书类型" prop="merchantCertType"
                              :rules="[{ required: true, message: '请选择证书类型'}]">
                    <el-select v-model="form.merchantCertType" placeholder="请选择">
                        <el-option label="非营业执照（含事业单位法人证等）" :value="1"></el-option>
                        <el-option label="事业单位法人证书" :value="3"></el-option>
                        <el-option label="民办非企业单位登记证书" :value="4"></el-option>
                        <el-option label="社会团体法人登记证书" :value="5"></el-option>
                        <el-option label="其他" :value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="登记证书照片" prop="licensePicFssId"
                              :rules="[{ required: true, message: '请选择登记证书照片'}]">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'licensePic')}">
<!--                        <i v-if="form.licensePic" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.licensePic)"></i>-->
                        <div class="icons" v-if="form.licensePic">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.licensePic)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
                        <img v-if="form.licensePic" :src="form.licensePic" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="登记证书号" prop="businessRegno"
                              :rules="[{ required: true, message: '请输入登记证书号'}]">
                    <el-input v-model="form.businessRegno" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经营单位名称" prop="merchantName"
                              :rules="[{ required: true, message: '请输入经营单位名称'}]">
                    <el-input v-model="form.merchantName" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="法定代表人" prop="legalName" :rules="[{ required: true, message: '请输入法定代表人'}]">
                    <el-input v-model="form.legalName" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经营范围" prop="merchantConstraintBusiness"
                              :rules="[{ required: true, message: '请输入经营范围'}]">
                    <el-input v-model="form.merchantConstraintBusiness" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经营场所地区编码" prop="merchantArea"
                              :rules="[{ required: true, message: '请选择经营场所地区'}]">
                    <!--                    <el-input v-model="form.merchantAreaCode" placeholder="请输入"-->
                    <!--                              auto-complete="off"></el-input>-->
                    <el-cascader
                        v-model="form.merchantArea"
                        :options="distinctData"
                        :props="{ value: 'id' }"
                        style="width: 100%"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="注册地址" prop="merchantAddress"
                              :rules="[{ required: true, message: '请输入注册地址'}]">
                    <el-input v-model="form.merchantAddress" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="登记证起始时间" prop="licenseHandleDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.licenseHandleDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="登记证结束时间" prop="licenseCancelDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.licenseCancelDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </div>
            <!--小微/小个体-->
            <div v-if="form.subjectType === 0">
                <el-form-item label="客户名称" prop="merchantName" :rules="[{ required: true, message: '请输入客户名称'}]">
                    <el-input v-model="form.merchantName" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经营地址" prop="merchantAddress"
                              :rules="[{ required: true, message: '请输入经营地址'}]">
                    <el-input v-model="form.merchantAddress" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经营场所地区编码" prop="merchantArea"
                              :rules="[{ required: true, message: '请选择经营场所地区'}]">
<!--                    <el-input v-model="form.merchantAreaCode" placeholder="请输入"-->
<!--                              auto-complete="off"></el-input>-->
                    <el-cascader
                        v-model="form.merchantArea"
                        :options="distinctData"
                        :props="{ value: 'id' }"
                        style="width: 100%"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="经营范围" prop="merchantConstraintBusiness" :rules="[{ required: true, message: '请输入经营范围'}]">
                    <el-input v-model="form.merchantConstraintBusiness" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div
                v-if="form.subjectType == 1 || form.subjectType == 2 || form.subjectType == 3 || form.subjectType == 4 || form.subjectType == 6">
                <el-form-item label="开户凭证照片" prop="accOpenFssId"
                              :rules="[{ required: true, message: '请选择开户凭证照片'}]">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'accOpen')}">
<!--                        <i v-if="form.accOpen" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.accOpen)"></i>-->
                        <div class="icons" v-if="form.accOpen">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.accOpen)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
                        <img v-if="form.accOpen" :src="form.accOpen" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="开户凭证代码" prop="accOpenCode"
                              :rules="[{ required: true, message: '请输入开户凭证代码'}]">
                    <el-input maxlength="11" v-model="form.accOpenCode" placeholder="请输入"
                              auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <el-form-item label="经营者/法人手机号" prop="mobile">
                <el-input maxlength="11" v-model="form.mobile" placeholder="请输入"
                          auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="身份证类型" prop="idType" :rules="[{ required: true, message: '请选择身份证类型'}]">
                <el-select v-model="form.idType" placeholder="请选择">
                    <el-option label="居民身份证" :value="1"></el-option>
                    <el-option label="港澳通行证" :value="2"></el-option>
                    <el-option label="台胞证" :value="3"></el-option>
                    <el-option label="外籍护照" :value="4"></el-option>
                    <el-option label="其他" :value="9"></el-option>
                </el-select>
            </el-form-item>
            <div v-if="form.idType == 1">
                <el-form-item label="身份证人像面照片" prop="idCardPersonFssId"
                              :rules="[{ required: true, message: '请选择身份证人像面照片'}]">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'idCardPerson')}">
<!--                        <i v-if="form.idCardPerson" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.idCardPerson)"></i>-->
                        <div class="icons" v-if="form.idCardPerson">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.idCardPerson)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
                        <img v-if="form.idCardPerson" :src="form.idCardPerson" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="身份证国徽面照片" prop="idCardNationalFssId"
                              :rules="[{ required: true, message: '请选择身份证国徽面照片'}]">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'idCardNational')}">
<!--                        <i v-if="form.idCardNational" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.idCardNational)"></i>-->
                        <div class="icons" v-if="form.idCardNational">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.idCardNational)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
                        <img v-if="form.idCardNational" :src="form.idCardNational" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="姓名" prop="idCardName" :rules="[{ required: true, message: '请输入姓名'}]">
                    <el-input v-model="form.idCardName" placeholder="请输入" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCardNumber" :rules="[{ required: true, message: '请输入身份证号'}]">
                    <el-input v-model="form.idCardNumber" maxlength="18" placeholder="请输入15位或者18位身份证号" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="有效期开始时间" prop="idCardBeginDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.idCardBeginDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="有效期结束时间" prop="idCardExpireDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.idCardExpireDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div v-if="form.idType == 2 || form.idType == 3 || form.idType == 4 || form.idType == 9">
                <el-form-item label="证件图片" prop="idDocFssId" :rules="[{ required: true, message: '请选择证件图片'}]">
                    <el-upload
                        class="avatar-uploader"
                        :action="$apiUrl.imgUpload"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                        :on-success="(res,file) => {return handleAvatarSuccess(res,file,'idDoc')}">
<!--                        <i v-if="form.idDoc" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.idDoc)"></i>-->
                        <div class="icons" v-if="form.idDoc">
                            <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.idDoc)"></i>
                            <i class="el-icon-upload2"></i>
                        </div>
                        <img v-if="form.idDoc" :src="form.idDoc" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="证件姓名" prop="idCardName" :rules="[{ required: true, message: '请输入证件姓名'}]">
                    <el-input v-model="form.idCardName" placeholder="请输入" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="证件号码" prop="idCardNumber" :rules="[{ required: true, message: '请输入证件号码'}]">
                    <el-input v-model="form.idCardNumber" placeholder="请输入" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="有效期开始时间" prop="idCardBeginDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.idCardBeginDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="有效期结束时间" prop="idCardExpireDate"
                              :rules="[{ required: true, message: '请选择时间'}]">
                    <el-date-picker
                        v-model="form.idCardExpireDate"
                        type="date"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="f16 bold pb20">3、商家账户信息</div>
            <el-form-item label="门店名称" prop="inDoorName" :rules="[{ required: true, message: '请输入门店名称'}]">
                <el-input  v-model="form.inDoorName" placeholder="请输入"
                          auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="门店省市区域" prop="inDoorAreas" :rules="[{ required: true, message: '请选择门店区域'}]">
                <el-cascader
                    v-model="form.inDoorAreas"
                    :options="distinctData"
                    :props="{ value: 'id' }"
                    style="width: 100%"
                ></el-cascader>
            </el-form-item>
            <el-form-item label="门店地址" prop="inDoorAddress" :rules="[{ required: true, message: '请输入门店地址'}]">
                <el-input  v-model="form.inDoorAddress" placeholder="请输入"
                           auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="门头照片" prop="headFssId" :rules="[{ required: true, message: '请选择门头照片'}]">
                <el-upload
                    class="avatar-uploader"
                    :action="$apiUrl.imgUpload"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :on-success="(res,file) => {return handleAvatarSuccess(res,file,'head')}">
<!--                    <i v-if="form.head" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.head)"></i>-->
                    <div class="icons" v-if="form.head">
                        <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.head)"></i>
                        <i class="el-icon-upload2"></i>
                    </div>
                    <img v-if="form.head" :src="form.head" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="门店内景照片" prop="inDoorFssId" :rules="[{ required: true, message: '请选择门店内景照片'}]">
                <el-upload
                    class="avatar-uploader"
                    :action="$apiUrl.imgUpload"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :on-success="(res,file) => {return handleAvatarSuccess(res,file,'inDoor')}">
<!--                    <i v-if="form.inDoor" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.inDoor)"></i>-->
                    <div class="icons" v-if="form.inDoor">
                        <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.inDoor)"></i>
                        <i class="el-icon-upload2"></i>
                    </div>
                    <img v-if="form.inDoor" :src="form.inDoor" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <div class="f16 bold pb20">4、补充材料</div>
            <el-form-item label="租赁协议或产权证明" prop="additionFssId"
                          :rules="[{ required: true, message: '请选择租赁协议或产权证明'}]">
                <span slot="label">
                    租赁协议或产权证明
                    <el-tooltip placement="right">
                        <div slot="content">
                            商户证明经营地址为租赁或自有房产
                        </div>
                        <i class="el-icon-question primary"></i>
                    </el-tooltip>
                </span>
                <el-upload
                    class="avatar-uploader"
                    :action="$apiUrl.imgUpload"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :on-success="(res,file) => {return handleAvatarSuccess(res,file,'addition')}">
<!--                    <i v-if="form.addition" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.addition)"></i>-->
                    <div class="icons" v-if="form.addition">
                        <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.addition)"></i>
                        <i class="el-icon-upload2"></i>
                    </div>
                    <img v-if="form.addition" :src="form.addition" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="开户意愿确认函" prop="openWillFssId"
                          :rules="[{ required: true, message: '请选择开户意愿确认函'}]">
                <span slot="label">
                    开户意愿确认函
                    <el-tooltip placement="right">
                        <div slot="content">
                            需要先下载模板文件，打印出来让商户签字后，再拍照上传
                        </div>
                        <i class="el-icon-question primary"></i>
                    </el-tooltip>
                </span>
                <a class="primary f12 cursor" href="http://qnvideo.anlaiye.com.cn/59c0aeb4c0a84252af1746433aa43978.doc">点击下载开户确认函文件</a>
                <el-upload
                    class="avatar-uploader"
                    :action="$apiUrl.imgUpload"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :on-success="(res,file) => {return handleAvatarSuccess(res,file,'openWill')}">
<!--                    <i v-if="form.openWill" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.openWill)"></i>-->
                    <div class="icons" v-if="form.openWill">
                        <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.openWill)"></i>
                        <i class="el-icon-upload2"></i>
                    </div>
                    <img v-if="form.openWill" :src="form.openWill" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="个人信息结算授权书" prop="personalSettleAuthFssId"
                          :rules="[{ required: true, message: '请选择个人信息结算授权书'}]"
                            v-if="form.settleAccType == 1">
                <span slot="label">
                    个人信息结算授权书
                    <el-tooltip placement="right">
                        <div slot="content">
                            个人信息单独同意授权书：需要先下载模板文件，打印出来让商家签字并加盖手印后，再拍照或扫描上传
                        </div>
                        <i class="el-icon-question primary"></i>
                    </el-tooltip>
                </span>
                <a class="primary f12 cursor" href="http://qnvideo.anlaiye.com.cn/9154c74ed5ed4b6eb139379055e6efcf.docx">点击下载个人信息结算授权书</a>
                <el-upload
                    class="avatar-uploader"
                    :action="$apiUrl.imgUpload"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :on-success="(res,file) => {return handleAvatarSuccess(res,file,'personalSettleAuth')}">
<!--                    <i v-if="form.personalSettleAuth" class="el-icon-zoom-in icon-zoom" @click.stop="handlePictureCardPreview(form.personalSettleAuth)"></i>-->
                    <div class="icons" v-if="form.personalSettleAuth">
                        <i class="el-icon-zoom-in" @click.stop="handlePictureCardPreview(form.personalSettleAuth)"></i>
                        <i class="el-icon-upload2"></i>
                    </div>
                    <img v-if="form.personalSettleAuth" :src="form.personalSettleAuth" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" type="primary" @click="submitForm('form')" :loading="submitLoading">提 交</el-button>
                <el-button size="mini" @click="resetForm('form')">重 置</el-button>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
import request from 'superagent';
export default {
    name: "shopInfo",
    data() {
        let checkMobile = (rule, value, callback) => {
            if (value && !this.$valid.mobile(value)) {
                callback(new Error('请输入正确格式的手机号'));
            }
            callback();
        };
        return {
            form: {
                email: '',
                settleAccType: '',
                pay_account: '',
                pay_name: '',
                bank_id: '',
                bank_name: '',
                bank_branch_id: '',
                bank_branch_name: '',
                bank_area: [],
                bank_province_code: '',
                bank_city_code: '',
                bank_area_code: '',
                authIdCardName: '',
                bankCard: '',
                bankCardFssId: '',
                authIdCardNumber: '',
                authIdCardBeginDate: '',
                authIdCardExpireDate: '',
                authIdCardPerson: '',
                authIdCardPersonFssId: '',
                authIdCardNational: '',
                authIdCardNationalFssId: '',
                authTel: '',
                pay_mp: '',
                subjectType: '',
                mobile: '',
                idType: 1,
                licensePic: '',
                licensePicFssId: '',
                businessRegno: '',
                merchantName: '',
                legalName: '',
                merchantConstraintBusiness: '',
                merchantArea: [],
                merchantAreaCode: '',
                merchantAddress: '',
                licenseHandleDate: '',
                licenseCancelDate: '',
                org: '',
                orgFssId: '',
                orgCode: '',
                tax: '',
                taxFssId: '',
                taxCode: '',
                merchantCertType: '',
                accOpen: '',
                accOpenFssId: '',
                accOpenCode: '',
                idCardName: '',
                idCardNumber: '',
                idCardBeginDate: '',
                idCardExpireDate: '',
                idCardPerson: '',
                idCardPersonFssId: '',
                idCardNational: '',
                idCardNationalFssId: '',
                idDoc: '',
                idDocFssId: '',
                head: '',
                inDoor: '',
                addition: '',
                openWill: '',
                headFssId: '',
                inDoorFssId: '',
                inDoorAreas: [],
                inDoorAddress: '',
                inDoorProvince: '',
                inDoorCity: '',
                inDoorArea: '',
                inDoorName: '',
                additionFssId: '',
                openWillFssId: '',
                personalSettleAuth: '',
                personalSettleAuthFssId: ''
            },
            rules: {
                email: [
                    {required: true, message: '请输入商户邮箱', trigger: 'blur'}
                ],
                settleAccType: [
                    {required: true, message: '请选择结算账号类型', trigger: 'blur'}
                ],
                pay_account: [
                    {required: true, message: '请输入银行账号', trigger: 'blur'}
                ],
                pay_name: [
                    {required: true, message: '请输入账号名称', trigger: 'blur'}
                ],
                bank_id: [
                    {required: true, message: '请选择银行名称', trigger: 'blur'}
                ],
                bank_branch_id: [
                    {required: true, message: '请选择支行名称', trigger: 'blur'}
                ],
                bank_area: [
                    {required: true, message: '请选择开户行区域', trigger: 'change'}
                ],
                pay_mp: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {validator: checkMobile, trigger: 'blur'}
                ],
                authIdCardName: [
                    {required: true, message: '请输入授权人姓名', trigger: 'blur'}
                ],
                authIdCardNumber: [
                    {required: true, message: '请输入授权人身份证号', trigger: 'blur'}
                ],
                authIdCardPersonFssId: [
                    {required: true, message: '请上传身份证人像面照片', trigger: 'blur'}
                ],
                authIdCardNationalFssId: [
                    {required: true, message: '请上传身份证国徽面照片', trigger: 'blur'}
                ],
                authIdCardBeginDate: [
                    {required: true, message: '请选择开始时间', trigger: 'change'}
                ],
                authIdCardExpireDate: [
                    {required: true, message: '请选择结束时间', trigger: 'change'}
                ],
                authTel: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {validator: checkMobile, trigger: 'blur'}
                ],
                mobile: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {validator: checkMobile, trigger: 'blur'}
                ],
                subjectType: [
                    {required: true, message: '请选择主体类型', trigger: 'blur'}
                ],
                idType: [
                    {required: true, message: '请选择身份证类型', trigger: 'change'}
                ]
            },
            loading: false,
            banks: [],
            allBankBranchs: [],
            bankBranchs: [],
            distinctData: [],
            commercialInfo: {},
            dialogVisible: false,
            dialogImageUrl: '',
            submitLoading: false,
            audit_status: '',
            audit_tips: ''
        }
    },
    created() {
        this.getBank();
        this.getDistinctTree();
        if(this.$route.params.id){
            this.fetchData();
        }
        if(this.$route.params.status){
            this.audit_status = this.$route.params.status;
            this.audit_tips = localStorage.getItem('auditTips');
        }
    },
    methods: {
        changeSubjectType() {
            if(this.form.subjectType === 6){
                this.form.legalName = '';
                this.form.merchantConstraintBusiness = '';
                this.form.merchantArea = [];
                this.form.merchantAreaCode = '';
                this.form.merchantAddress = '';
                this.form.merchantName = '';
                this.form.businessRegno = '';
                this.form.licensePic = '';
                this.form.licensePicFssId = '';
                this.form.licenseHandleDate = '';
                this.form.licenseCancelDate = '';
            }else{
                this.$refs['form'].clearValidate('merchantName');
                if(this.commercialInfo.license_list && this.commercialInfo.license_list.length > 0){
                    let license_list = JSON.parse(this.commercialInfo.license_list);
                    this.form.licensePic = license_list[0].license;
                    if(!this.form.licensePicFssId){
                        this.getKqUploadCode('licensePic', this.form.licensePic);
                    }
                    if(!this.form.businessRegno){
                        this.getImgInfo('licensePic', this.form.licensePic, 1);
                    }
                }
            }
        },
        fetchData() {
            this.$api.get(this.$apiUrl.commercialInfo, {id: this.$route.params.id}, (res) => {
                if(res.data && res.data.id){
                    this.commercialInfo = res.data;
                    for(let k1 in res.data){
                        for(let k2 in this.form){
                            if(k2 == k1 && (res.data[k1] || res.data[k1] === 0)){
                               this.form[k2] = res.data[k1];
                            }
                        }
                    }
                    if(this.form.bank_id){
                        if(this.form.bank_branch_id){
                            this.bankBranchs = [{k: this.form.bank_branch_id, n: this.form.bank_branch_name}]
                        }
                    }
                    if(this.form.bank_province_code && this.form.bank_city_code){
                        this.form.bank_area = [parseInt(this.form.bank_province_code), parseInt(this.form.bank_city_code), parseInt(this.form.bank_area_code)];
                    }
                    if(this.form.inDoorProvince && this.form.inDoorCity){
                        this.form.inDoorAreas = [parseInt(this.form.inDoorProvince), parseInt(this.form.inDoorCity), parseInt(this.form.inDoorArea)];
                    }
                    if(this.form.merchantAreaCode){
                        setTimeout(() => {
                            let pCode, cCode;
                            for(let v of this.distinctData){
                                if(v.children){
                                    let children1 = v.children;
                                    for(let v1 of children1){
                                        if(v1.children){
                                            let children2 = v1.children;
                                            for(let v2 of children2){
                                                if(v2.id == this.form.merchantAreaCode){
                                                    cCode = v1.id;
                                                    pCode = v.id;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            this.form.merchantArea = [pCode, cCode, parseInt(this.form.merchantAreaCode)];
                        },2000)
                    }
                    // 营业执照
                    if(res.data.license_list && res.data.license_list.length > 0){
                        let license_list = JSON.parse(res.data.license_list);
                        this.form.licensePic = license_list[0].license;
                        if(!this.form.licensePicFssId){
                            this.getKqUploadCode('licensePic', this.form.licensePic);
                        }
                        if(!this.form.businessRegno){
                            this.getImgInfo('licensePic', this.form.licensePic, 1);
                        }
                    }
                    // 身份证
                    if(!this.form.idCardPersonFssId && !this.form.idCardNationalFssId){
                        if(res.data.cert_front_img && res.data.cert_back_img){
                            this.form.idCardPerson = res.data.cert_front_img;
                            this.form.idCardNational = res.data.cert_back_img;
                            this.getKqUploadCode('idCardPerson', this.form.idCardPerson);
                            this.getKqUploadCode('idCardNational', this.form.idCardNational);
                            this.getImgInfo('idCardPerson', this.form.idCardPerson, 3);
                            this.getImgInfo('idCardNational', this.form.idCardNational, 4);
                        }
                    }
                }
            })
        },
        submitForm(formName) {
            // console.log(this.form)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.form.bank_province_code = this.form.bank_area[0];
                    this.form.bank_city_code = this.form.bank_area[1];
                    this.form.bank_area_code = this.form.bank_area[2];
                    this.form.inDoorProvince = this.form.inDoorAreas[0];
                    this.form.inDoorCity = this.form.inDoorAreas[1];
                    this.form.inDoorArea = this.form.inDoorAreas[2];
                    this.form.merchantAreaCode = this.form.merchantArea[2];
                    let params = {...this.form};
                    delete params.bank_area;
                    delete params.inDoorAreas;
                    delete params.merchantArea;
                    params.commercial_id = this.$route.params.id;
                    params.shop_id = this.$route.params.sid;
                    params = this.$utils.filterNull(params);
                    this.$api.post(this.$apiUrl.bindKq, params, (res) => {
                        this.$message.success('保存成功');
                        this.$router.push({path:`/saas/shop/info`});
                        this.submitLoading = false;
                    }, (res) => {
                        this.$message.warning(res.message);
                        this.submitLoading = false;
                    })
                } else {
                    return false;
                }
            });
        },
        //获取银行
        getBank() {
            this.$api.get(this.$apiUrl.getBank, {}, (res) => {
                this.banks = [];
                for (let k in res.data) {
                    this.banks.push({k: parseInt(k), n: res.data[k]});
                }
            })
        },
        //获取支行
        getBankBranch(flag) {
            if (this.form.bank_id) {
                this.$api.get(this.$apiUrl.getBankBranch, {bank_id: this.form.bank_id}, (res) => {
                    this.allBankBranchs = [];
                    if (!flag) this.form.bank_branch_id = '';
                    for (let k in res.data) {
                        this.allBankBranchs.push({k: k, n: res.data[k]});
                    }
                })
                this.banks.map((item) => {
                    if (item.k == this.form.bank_id) {
                        this.form.bank_name = item.n;
                    }
                })
            }
        },
        getBranchName() {
            if (this.form.bank_branch_id) {
                this.bankBranchs.map((item) => {
                    if (item.k == this.form.bank_branch_id) {
                        this.form.bank_branch_name = item.n;
                    }
                })
            }
        },
        bankRemoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    let temp = [];
                    temp = this.allBankBranchs.filter(function (item) {
                        return item.n.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                    });
                    if (temp.length > 50) {
                        this.bankBranchs = temp.slice(temp.length - 50);
                    } else {
                        this.bankBranchs = temp;
                    }
                }, 600);
            } else {
                this.bankBranchs = [];
            }
        },
        getDistinctTree() {
            this.$apiOuter.get(this.$apiUrl.distinctTree, {type: 1}, (res) => {
                this.distinctData = res.data;
            }, 'pub-base')
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            const isLt50M = file.size / 1024 / 1024 < 50;

            // if (!isJPG) {
            //     this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt50M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt50M;
        },
        handlePictureCardPreview(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },
        handleAvatarSuccess(res, file, key) {
            this.form[key] = res.url;
            this.getKqUploadCode(key, res.url);
            if(key == 'licensePic'){
                this.getImgInfo(key,res.url,1);
            }
            if(key == 'idCardPerson' || key == 'authIdCardPerson'){
                this.getImgInfo(key,res.url,3);
            }
            if(key == 'idCardNational' || key == 'authIdCardNational'){
                this.getImgInfo(key,res.url,4);
            }
        },
        // 上传至快钱
        getKqUploadCode(key, url) {
            this.$apiJava.post(this.$apiUrl.kqUption + '?url=' + url, {}, (res) => {
                this.form[key + 'FssId'] = res.data;
            }, null,'payment')
        },
        // 识别图片信息
        getImgInfo(key, url, type) {
            let apiUrl = this.$apiUrl.imgOrc + '?mobile='+localStorage.getItem('account')+'&url=' + url + '&type=' + type + '&token=' + this.$store.getters.token + '&sysCode=1';
            let r = request('POST', apiUrl).type('application/x-www-form-urlencoded');
            r.end((err, res) => {
                if (res.body.flag && res.body.flag > 0 && res.body.result) {
                    if(res.body.data){
                        let data = res.body.data;
                        if(key == 'licensePic'){
                            this.form.businessRegno = data.creditCode;
                            this.form.merchantName = data.companyName;
                            this.form.legalName = data.legalPerson;
                            this.form.merchantConstraintBusiness = data.businessScope;
                            // this.form.merchantAreaCode = data.businessScope;
                            this.form.merchantAddress = data.businessAddress;
                            this.form.licenseHandleDate = data.formatFromDate;
                            this.form.licenseCancelDate = data.formatToDate;
                        }
                        if(key == 'idCardPerson' || key == 'authIdCardPerson'){
                            this.$utils.decrypt(data.nameEncry,(str)=>{
                                if(str){
                                    if(key == 'idCardPerson'){
                                        this.form.idCardName = str;
                                    }
                                    if(key == 'authIdCardPerson'){
                                        this.form.authIdCardName = str;
                                    }
                                }
                            })
                            this.$utils.decrypt(data.idNumberEncry,(str)=>{
                                if(str){
                                    if(key == 'idCardPerson'){
                                        this.form.idCardNumber = str;
                                    }
                                    if(key == 'authIdCardPerson'){
                                        this.form.authIdCardNumber = str;
                                    }
                                }
                            })
                        }
                        if(key == 'idCardNational'){
                            this.form.idCardBeginDate = (data.validPeriod.split('-')[0]).replaceAll('.','-');
                            this.form.idCardExpireDate = (data.validPeriod.split('-')[1]).replaceAll('.','-');;
                        }
                        if(key == 'authIdCardNational'){
                            this.form.authIdCardBeginDate = (data.validPeriod.split('-')[0]).replaceAll('.','-');
                            this.form.authIdCardExpireDate = (data.validPeriod.split('-')[1]).replaceAll('.','-');;
                        }
                    }
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            for(let k in this.form){
                this.form[k] = '';
            }
            this.form.idType = 1;
        }
    }
}
</script>

<style scoped>
.avatar-uploader img {
    width: 150px;
    height: 150px;
}
.avatar-uploader .el-upload:hover{
    background-color: #999;
}
.avatar-uploader .icons{
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.4);
    display: flex;
    justify-content: center;
    align-items: center;
}
.avatar-uploader .icons i{
    color: #fff;
    font-size: 26px;
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// bindKq.vue?1f7e7fb7